import React, { useState } from "react";
import UploadIcon from "@assets/images/NoSubscriptionAstronot.png";
import { Link } from "react-router-dom";
import { getCheckoutLink } from "@api/authService";
import { useUserData } from "@context/OAuth/AuthContext";
import { toast } from "react-toastify";
import ButtonLoader from "./Loaders/ButtonLoader";
import { useTranslation } from "react-i18next";
const URL_TO_NAVIGATE = process.env.REACT_APP_WORDPRESS_URL;
const SubscribtionSuspended = () => {
  const { subscription } = useUserData();

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleNavigate = async () => {
    try {
      setLoading(true);
      const response = await getCheckoutLink(subscription?.subscription_id);
      if (response && response.payment_url) {
        // 3. Use standard browser navigation for external links
        window.location.href = response.payment_url;
      } else {
        toast.error("Your subscription has been cancelled. Please contact to support");
      }
    } catch (error) {
      console.log("error getting checkout url:", error);
      toast.error("Your subscription has been cancelled. Please contact to support");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      className={`p-2 bg-white max-h-[587px] h-screen rounded-[12px] flex flex-col justify-center items-center`}
    >
      <img
        src={UploadIcon}
        className="border-[1px] border-solid border-white rounded-[50%] p-1 "
        alt={"Upload icon"}
      />
      <h2 className="text-[24px] font-[700] text-[#303030] text-center font-Lato">
        {t("Looks Like Your Subscription Has Ended")}
      </h2>
      <p className="text-[#6C6C6C] text-[16px] font-[Lato] text-center my-2 max-w-[80%]">
        {t("Renew now to keep your personalized fitness journey going.")}
      </p>
      <button
        to={`${URL_TO_NAVIGATE}/checkout/`}
        className="px-[18px] py-[10px] bg-[#64DDFF] text-white rounded-[32px] flex items-center justify-center gap-2 disabled:opacity-80 min-w-[180px]"
        disabled={loading}
        onClick={handleNavigate}
      >
        {/* <img
          src={UploadIcon}
          className="border-[1px] border-solid border-white rounded-[50%] p-1 "
          alt={"Upload icon"}
        /> */}
        {loading ? <ButtonLoader /> : t("Renew Subscription")}
      </button>
    </div>
  );
};

export default SubscribtionSuspended;
